export enum TABLE_APIS {
    Get = 0,
    Delete = 1,
    Update = 2
}